/* eslint-disable react/no-unknown-property */
import React from 'react';

interface PlayAudioIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const PlayAudioIcon: React.FC<PlayAudioIconProps> = ({
  width = 16,
  height = 16,
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_37065_341354)">
      <path
        d="M4.66675 2.66669V13.3334L13.3334 8.00002L4.66675 2.66669Z"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_37065_341354">
        <rect width="16" height="16" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
